export default __webpack_public_path__ + "static/media/emi_m.0e3328bf.jpg";